import { render } from "./ListaCarga.vue?vue&type=template&id=2fb18af0&scoped=true"
import script from "./ListaCarga.vue?vue&type=script&lang=js"
export * from "./ListaCarga.vue?vue&type=script&lang=js"

import "./ListaCarga.vue?vue&type=style&index=0&id=2fb18af0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fb18af0"

export default script